<template>
  <!-- Help dialog -->
  <v-dialog
    v-model="dialog"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-if="!$scopedSlots.activator"
        v-on="on"
        v-bind="attrs"
        icon
        x-small
        :class="{ 'float-right': right }"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      <slot
        name="activator"
        :on="on"
        :attrs="attrs"
      ></slot>
    </template>

    <!-- Help card with sugestions -->
    <v-card>
      <v-card-title v-if="title" class="text-left word-wrap">
        {{ title }}
      </v-card-title>

      <v-progress-circular
        v-if="loading"
        indeterminate
        size="50"
      ></v-progress-circular>
      <v-card-text v-else class="text-left">
        <slot></slot>
      </v-card-text>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "HelpPopup",
  props: {
    title: {
      type: String,
      required: true,
      default: "",
    },
    right: {
      type: Boolean,
      required: false,
      default: false,
    },
    loading: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
  }),
  watch: {
    dialog(newVal) {
      if (newVal)
        this.$emit("open");
      else
        this.$emit("close");
    }
  },
}
</script>
<style scoped lang="scss">
.float-right {
  float: right;
}
.word-wrap {
  word-break: normal !important;
}
</style>